export interface ParsedParams {
  clientId: string
  redirectUri: string
  scopes: string[]
  state: string | null
  codeChallengeMethod: string | null
  codeChallenge: string | null
  responseType: string
}

export interface ValidationError {
  type: 'missing' | 'invalid_request'
  field: string
  detail?: string
}

export const parseAndValidateParams = (searchParams: URLSearchParams): { params: ParsedParams | null; validationErrors: ValidationError[] } => {
  const clientId = searchParams.get('client_id')
  const redirectUri = searchParams.get('redirect_uri')
  const scope = searchParams.get('scope')
  const state = searchParams.get('state')
  const responseType = searchParams.get('response_type')
  const codeChallengeMethod = searchParams.get('code_challenge_method') || null
  const codeChallenge = searchParams.get('code_challenge') || null

  const validationErrors: ValidationError[] = []

  if (!clientId) {
    validationErrors.push({ type: 'missing', field: 'client_id' })
  }
  if (!redirectUri) {
    validationErrors.push({ type: 'missing', field: 'redirect_uri' })
  }
  if (!scope) {
    validationErrors.push({ type: 'missing', field: 'scope' })
  }
  if (!responseType) {
    validationErrors.push({ type: 'missing', field: 'response_type' })
  }

  if (codeChallenge && !codeChallengeMethod) {
    validationErrors.push({ type: 'invalid_request', field: 'pkce_mismatch', detail: 'code_challenge provided without code_challenge_method' })
  }
  if (!codeChallenge && codeChallengeMethod) {
    validationErrors.push({ type: 'invalid_request', field: 'pkce_mismatch', detail: 'code_challenge_method provided without code_challenge' })
  }

  if (validationErrors.length > 0 || !clientId || !redirectUri || !scope || !responseType) {
    return { params: null, validationErrors }
  }

  return {
    params: {
      clientId,
      redirectUri,
      scopes: scope.trim().split(/\s+/).filter(Boolean),
      state,
      codeChallengeMethod,
      codeChallenge,
      responseType,
    },
    validationErrors: [],
  }
}

export const formatValidationErrorCode = (errors: ValidationError[]): string => {
  return errors
    .map((e) => {
      if (e.type === 'missing') {
        return `missing: ${e.field}`
      }
      return `error: ${e.type} · ${e.field}`
    })
    .join(', ')
}
